import { useEffect, useState } from 'react';
// Hook
export default function useMobileVh() {
    const [vh, setVh] = useState(window.innerHeight * 0.01);
    useEffect(() => {
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, [vh]);
    useEffect(() => {
        const handleResize = () => {
            setVh(window.innerHeight * 0.01);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
}
//# sourceMappingURL=UseMobileVh.js.map